import React from 'react'
import moment from 'moment'

export default ({ value, format = 'L' }) => (
  <span className="localized-date">
    {value ? moment(value).format(format) : "-"}
  </span>
)
